<template>
    <form-row title="Dates">
        <div class="flex flex-col sm:flex-row flex-1 -mt-2 sm:-mt-4">
            <div class="sm:mr-4">
                <input-date
                    label="List Date"
                    name="list_date"
                    v-model="list_date"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-4 sm:mt-0 sm:ml-4">
                <input-date
                    label="Scheduled Closing Date"
                    name="scheduled_closing_date"
                    v-model="scheduled_closing_date"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
    },

    computed: {
        list_date: {
            get() {
                return store.state.list_date;
            },
            set(val) {
                store.state.list_date = val;
            },
        },
        scheduled_closing_date: {
            get() {
                return store.state.scheduled_closing_date;
            },
            set(val) {
                store.state.scheduled_closing_date = val;
            },
        },
    },
}
</script>
